import { pxToRem } from '@withjoy/joykit/theme';

// Map Pin Image Styling Constants
// The large border width is specifically designed to create a prominent glass-like border effect
// for large map pin images, providing visual depth and ensuring proper contrast against map backgrounds
export const LARGE_IMAGE_BORDER_WIDTH_PX = 3.56;
export const LARGE_IMAGE_BORDER_WIDTH = pxToRem(LARGE_IMAGE_BORDER_WIDTH_PX);
export const STANDARD_IMAGE_BORDER_WIDTH = '1px';
export const GLASS_BORDER_COLOR = 'var(--Glass, rgba(255, 255, 255, 0.72))';
export const STANDARD_BORDER_COLOR = 'rgba(255, 255, 255, 0.72)';

// Map Card Positions
export const MAP_CARD_POSITIONS = {
  TOP_LEFT: 'top-left',
  TOP_CENTER: 'top-center',
  TOP_RIGHT: 'top-right',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_CENTER: 'bottom-center',
  BOTTOM_RIGHT: 'bottom-right',
} as const;

// Map Animation Assets
export const MAP_ANIMATION_ICON_URL = 'https://heygirl.cutestperson.com/assets/public/apps/travel/lotties/map-animation.json';
